export default "__VITE_ASSET__D81GpSpm__"